import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        console.log(
          'ServiceWorker registrado com sucesso: ',
          registration.scope
        );
      })
      .catch(error => {
        console.log('Falha ao registrar o ServiceWorker: ', error);
      });
  });
}
